<template>
  <main class="page document-page">
    <div class="document-page__container">
      <ul class="breadcrumbs">
        <li class="breadcrumbs__item">
          <router-link :to="{ name: 'home'}">Главная</router-link>
        </li>
        <li class="breadcrumbs__item">
          <span>Документы</span>
        </li>
      </ul>
      <h1 class="document-page__title">Документы</h1>
      <div class="document-page__content">
        <div class="document-page__search">
          <i class="document-page__search__icon" aria-hidden="true">
            <search-icon/>
          </i>
          <input class="document-page__search__input" type="text" autocomplete="off" title="Поиск по заголовку и названию документа" placeholder="Поиск по заголовку и названию документа" v-model="search"/>
        </div>
        <ul class="document-page__list" v-if="search.length === 0">
          <li class="document-page__list__li" v-for="(categories, index) in $store.state.categories" :key="index">
            <router-link :to="{ name: 'documentsOpen', params: { id: categories.id } }" class="document-page__list__link">
              <h2>{{ categories.title }}</h2>
              <span>{{ categories.connect_documents.length }}</span>
            </router-link>
          </li>
        </ul>
        <div class="document-page__table" v-else>
          <div class="document-page__table__header">
            <span>Название документа</span>
            <span>Дата публицации</span>
          </div>
          <ul class="document-page__table__body">
            <li class="document-page__table__item" v-for="(document, index) in documents" :key="index">
              <router-link :to="{ name: 'documentsShow', params: { cat_id: document.category_id, id: document.id} }">
                <h2 style="color: brown">{{ document.title }}</h2>
              </router-link>
              <time :datetime="document.date_publication | robotDate">{{ document.date_publication | humanDate }}</time>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import SearchIcon from 'components/svg/SearchIcon.vue'

export default {
  async asyncData ({ store }) {
    await store.dispatch('DOCUMENTS_PAGE')
  },
  name: 'DocumentsPage',
  data () {
    return {
      search: ''
    }
  },
  computed: {
    documents () {
      return this.$store.state.categories.map(item => item.connect_documents).flat().filter(item => item.title.toLowerCase().includes(this.search.toLowerCase()))
    }
  },
  components: { SearchIcon },
  metaInfo () {
    return this.$seo(
      'common',
      'Документы',
      'управление образования, образование',
      '',
      'Документы',
      '',
      ''
    )
  }
}
</script>
